export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15104.3436e4ca.jpg";